import { useEffect, useMemo, useState } from 'preact/hooks';
import {
  exchangeCodeForTokens,
  getCognitoOAuthConfig,
} from './cognito-oauth';
import { OAUTH_ACCESS_TOKEN_KEY } from './connect-api';

export function OAuthCallbackPage() {
  const oauthConfig = useMemo(() => getCognitoOAuthConfig(), []);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!oauthConfig) {
      setError('Missing Cognito OAuth env vars.');
      return;
    }

    const params = new URLSearchParams(window.location.search);
    const oauthError = params.get('error_description') ?? params.get('error');
    if (oauthError) {
      setError(oauthError);
      return;
    }

    const code = params.get('code');
    const connectionToken = params.get('state');

    if (!code) {
      setError('Missing authorization code from Cognito.');
      return;
    }

    if (!connectionToken) {
      setError('Missing connection token in OAuth state.');
      return;
    }

    exchangeCodeForTokens(oauthConfig, code)
      .then((tokens) => {
        sessionStorage.setItem(OAUTH_ACCESS_TOKEN_KEY, tokens.access_token);
        window.location.replace(`/connect?token=${encodeURIComponent(connectionToken)}`);
      })
      .catch((err) => {
        const message = err instanceof Error ? err.message : 'OAuth sign-in failed';
        setError(message);
      });
  }, [oauthConfig]);

  return (
    <div class="connect">
      <div class="connect-card">
        <div class="brand-logo">
          <img
            src="/logos/noddpayc.png"
            alt="NoddPay"
            width={64}
            height={64}
          />
        </div>
        <header class="connect-header">
          <h1>Signing in...</h1>
        </header>
        {error ? (
          <p class="error">{error}</p>
        ) : (
          <p class="hint">Completing NoddPay sign-in. You will be redirected shortly.</p>
        )}
      </div>
    </div>
  );
}
